import type { ProcessingProgress } from "./processing-runs-provider";

/** Ignore a finished-looking poll until this session has seen the run processing. */
export function progressForTrackedRun(
  progress: ProcessingProgress,
  seenRunning: boolean,
): ProcessingProgress {
  if (progress.state === "running") {
    return progress;
  }
  if (!seenRunning) {
    return { ...progress, state: "waiting" };
  }
  if (progress.state === "waiting") {
    return { ...progress, state: "failed" };
  }
  return progress;
}
